import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const ChapterHead = ({ index, title, inverted = false, sub }) => (
  <Reveal>
    <div className={`flex items-baseline gap-4 sm:gap-6 border-b pb-6 ${sub ? "mb-5" : "mb-12 sm:mb-16"} ${inverted ? "border-black/15" : "border-blue-100/10"}`}>
      <span className={`font-meta text-xs sm:text-sm tracking-[0.3em] ${inverted ? "text-black/50" : "text-blue-300/60"}`}>
        {index}
      </span>
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight uppercase leading-none">
        {title}
      </h2>
    </div>
    {sub && (
      <p className={`text-sm sm:text-base font-light leading-relaxed max-w-2xl mb-12 sm:mb-16 ${inverted ? "text-black/60" : "text-blue-100/60"}`}>
        {sub}
      </p>
    )}
  </Reveal>
);
